import { LVTMetric, LVTMetricData, LVTMetricEvent } from './types';

export const lvtMetricEvent = <Category extends keyof LVTMetric>(
  eventCategory: LVTMetricData<Category>['eventCategory'],
  data: object,
  eventAction?: LVTMetricData<Category>['eventAction'],
  eventStep?: LVTMetricData<Category>['eventStep'],
  eventLabel?: LVTMetricData<Category>['eventLabel']
): [LVTMetricEvent, LVTMetricData<Category>] => [
  'lvt_metric',
  {
    eventCategory,
    eventScope: 'learning_platform_frontend',
    eventAction,
    eventStep,
    eventLabel,
    ...data,
  },
];
